import { render, staticRenderFns } from "./AdsListPrograms.vue?vue&type=template&id=233d91a0&scoped=true&"
import script from "./AdsListPrograms.vue?vue&type=script&lang=js&"
export * from "./AdsListPrograms.vue?vue&type=script&lang=js&"
import style0 from "./AdsListPrograms.vue?vue&type=style&index=0&id=233d91a0&prod&lang=scss&scoped=true&"
import style1 from "./AdsListPrograms.vue?vue&type=style&index=1&id=233d91a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d91a0",
  null
  
)

export default component.exports